import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';


@Component({
  selector: 'k-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.less']
})
export class ProgressBarComponent implements OnInit {

  @Output() goNext = new EventEmitter()
  @Output() changeCurrentIndex = new EventEmitter();
  @Output() openDrawer = new EventEmitter();

  @Input() showSidebar
  

  @Input() startIndex
  @Input() endIndex

  @Input() activeIndex

  @Input() toggleSidebarTemplate:TemplateRef<any>|null = null

  drawerOpened:boolean = true

  constructor() { }

  ngOnInit(): void {
    this.drawerOpened = this.showSidebar
    
 
  }
  changeIndex(direction ,event:MouseEvent){
    event.stopPropagation()
    this.goNext.emit(direction)
  }

  seeTag(){
    this.drawerOpened = !this.drawerOpened;
    this.openDrawer.emit(this.drawerOpened)
  }
  handleChange(data){
    this.changeCurrentIndex.emit(data.value)
  }
}
